module.exports = __webpack_public_path__ + "img/myPetList_cat.f645dcd6.svg";